import request from '@/utils/request'

/**
 * 获取岗位信息(oauth)
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function oauthPostInfoGet(data) {
  return request({
    type: 'base',
    url: 'oauth/post/info/get',
    method: 'post',
    data
  })
}
/**
 * 新增职位
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function postAdd(data) {
  return request({
    type: 'base',
    url: 'post/add',
    method: 'post',
    data
  })
}
/**
 * 删除职位
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function postDelete(data) {
  return request({
    type: 'base',
    url: 'post/delete',
    method: 'post',
    data
  })
}
/**
 * 根据职位类别获取职位列表
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function postList(data) {
  return request({
    type: 'base',
    url: 'post/list',
    method: 'post',
    data
  })
}
/**
 * 根据组织获取职位列表(不按职位类型分类)
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function postOrgList(data) {
  return request({
    type: 'base',
    url: 'post/org/list',
    method: 'post',
    data
  })
}
/**
 * 根据组织获取职位列表
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function postOrgTypeList(data) {
  return request({
    type: 'base',
    url: 'post/org/type/list',
    method: 'post',
    data
  })
}
/**
 * 新增职位类型
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function postTypeAdd(data) {
  return request({
    type: 'base',
    url: 'post/type/add',
    method: 'post',
    data
  })
}
/**
 * 删除职位类型
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function postTypeDelete(data) {
  return request({
    type: 'base',
    url: 'post/type/delete',
    method: 'post',
    data
  })
}
/**
 * 获取职位类型详情
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function postTypeDetailGet(data) {
  return request({
    type: 'base',
    url: 'post/type/detail/get',
    method: 'post',
    data
  })
}
/**
 * 获取职位类型列表
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function postTypeListGet(data) {
  return request({
    type: 'base',
    url: 'post/type/list/get',
    method: 'post',
    data
  })
}
/**
 * 编辑职位类型
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function postTypeUpdate(data) {
  return request({
    type: 'base',
    url: 'post/type/update',
    method: 'post',
    data
  })
}
/**
 * 编辑职位
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function postUpdate(data) {
  return request({
    type: 'base',
    url: 'post/update',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/Post.js